goog.provide('el8.appchart.refpanel.setup');

goog.require('el8.app.shared.dialog.apptHistory');
goog.require('el8.appchart.dialog.growthChart');
goog.require('el8.appchart.refpanel.hccScoreDetails');
goog.require('el8.appchart.refpanel.compareRefpanel');
goog.require('el8.appchart.refpanel.uploadPtPhoto');
goog.require('el8.practicedata.immunizationRegistries');
goog.require('el8.ptdata.hccScoreDetails');
goog.require('el8.ptdata.ptNextAppt');
goog.require('el8.ptdata.ptRegistrationInfo');
goog.require('el8.template.appchart.refpanel.appts');
goog.require('el8.template.appchart.refpanel.ptRegistrationInfo');
goog.require('el8.uiwidget.NewActionsMenu');
goog.require('el8.util.amplitude.immunizationHelpers');

// Right now, this needs to run *after* the other sections
// have been displayed because the triggers might not be on the DOM
//
// In the future, we should move this to the appchart/init folder, and
// the input fields should be on the DOM upon render
el8.appchart.refpanel.setup = function() {

    var $refBoard = $('#refBoard');

    if (el8Globals['TEASE']) {
        $('.refHeader, .allergyHeader', $refBoard).each(function(i, elt) {
            $(this).trigger('el8_collapse').unbind('click');
        });
    }

    var nextApptTime = el8.ptdata.ptNextAppt.getApptTime();
    $('#next-appt-section', $refBoard).html(
        el8.template.appchart.refpanel.appts.nextAppt({
            isToday: nextApptTime ? el8.util.datecompare.isToday(nextApptTime) : false,
            apptTime: el8.service.tz.soyStr(nextApptTime)
        })
    );

    $('#refboard-portal-section', $refBoard).html(
        el8.template.appchart.refpanel.ptRegistrationInfo.content(
            el8.ptdata.ptRegistrationInfo.asSoyMap()
        )
    );

    el8.appchart.refpanel.actionsMenu = new el8.uiwidget.NewActionsMenu({
        container: $('.ref-board-body', $refBoard),
        anchorTop: $('.ref-board-body', $refBoard),
        menuId: 'ref-panel-actions-menu',
        width: 200
    });

    // no single refpanel file manages "other-info"
    $('#refBoardContainer').on('click', '.other-info-actions-trigger',  function() {
        var menu = [
            {
                actionText: 'See Growth Charts',
                actionFn: function() { el8.appchart.dialog.growthChart.show(); }
            },
            {
                actionText: 'Print Immunization History',
                actionFn: function() {
                    el8.appchart.printService.open({
                        attachmentId: 'ImmHistory',
                        urlKey: 'printImmunizations'
                    });
                    el8.util.amplitude.logImmunizationClinicalProfilePrint();
                }
            }
        ];
        /**
         * Add "Check Registry" menu item if the practice has Immunization Registries
         * with one of the appropriate history integration types
         */
        if (el8.practicedata.immunizationRegistries.canCheckRegistryHistoryForecast()) {
            menu.push({
                actionText: 'Check Registry',
                actionFn: function() {
                    el8.util.amplitude.logImmunizationHistoryOpenHistoryDialog('clinical profile actions');
                    el8React.dispatch.openImmunizationHistoryDialog();
                }
            });

            menu.push({
                actionText: 'Check Forecast',
                actionFn: function() {
                    el8.util.amplitude.logImmunizationForecastOpenForecastDialog('clinical profile actions');
                    el8React.dispatch.openImmunizationForecastDialog();
                }
            });
        }
        el8.appchart.refpanel.actionsMenu.display(
            $(this), null,
            {'top': 17, 'left': 20},
            menu
        );
        return false;
    });

    // Photo uploader for patient profile pics
    $refBoard.on('click', '.pt-profile-photo-section',  function() {
        el8.appchart.refpanel.uploadPtPhoto.show();
    });

    $refBoard.on('click', '.appt-hx-trigger',  function() {
        el8.app.shared.dialog.apptHistory.showCurrentPt();
    });

    if (el8Globals.FEATURES.PLR) {
        el8.appchart.refpanel.compareRefpanel.checkPlrProfileStatus();
    }

    // init the hcc score and add trigger
    if (el8.data.practiceSettings.isHccScoringEnabled()) {
        var cb = function(data) {
            var cf = el8.ptdata.hccScoreDetails.getCommunityFinal();
            $('.refboard-pt-risk-section').show();
            $('.refboard-pt-risk-score').html(cf);
        };

        el8.ptdata.hccScoreDetails.refresh(cb);

        $refBoard.on('click', '.refboard-pt-risk-trigger',  function() {
            el8.appchart.refpanel.hccScoreDetails.show();
        });
    }
};

// has its own function b/c we're not caching this value
el8.appchart.refpanel.setupLastAppt = function(serverDateTime) {
    var lastApptTime = serverDateTime ?
        el8.service.tz.newTzDateTime(serverDateTime) : null;
    var isToday = lastApptTime ? el8.util.datecompare.isToday(lastApptTime) : false;
    $('#last-appt-section').html(
        el8.template.appchart.refpanel.appts.lastAppt({
            isToday: isToday,
            apptTime: serverDateTime // don't need to call soyStr - it's already in server format
        })
    );
};
